function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import ReactDOM from "react-dom";
import React from "react";
import { WDHComponent, resolveImageSrc } from "@demant/wdh";
import DemantIntroBannerHero from "./hero";
import DemantIntroBannerRegular from "./regular";

/**
 * @memberOf module: component-intro-banner
 */
var DemantIntroBannerSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function DemantIntroBannerSpot() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "intro-banner";
    _classCallCheck(this, DemantIntroBannerSpot);
    _this = _callSuper(this, DemantIntroBannerSpot, [className]);

    /**
     * Set a callback function to override the default logic for when to switch between
     * *mobile* and *desktop* views. Return true to go to *mobile*, return false to go to
     * *desktop*.
     * @type {function(int, int): boolean}
     */
    _this.resolveMobileBreakPoint = _this.defaultResolveMobileBreakPoint;

    /**
     * The react application to instantiate
     * @type {React.Component}
     */
    _this.reactApp = DemantIntroBannerRegular;
    return _this;
  }
  _inherits(DemantIntroBannerSpot, _WDHComponent);
  return _createClass(DemantIntroBannerSpot, [{
    key: "init",
    value: function init(component) {
      var settings = this.getDataFromComponent(component);
      var addNudge = component.classList.contains("nudge");
      var sliderStack = component.classList.contains("slider-stack");
      ReactDOM.render(/*#__PURE__*/React.createElement(this.reactApp, _objectSpread(_objectSpread({}, settings), {}, {
        mobileImageSrc: settings.mobileImageData.mobileImagesSrc || settings.desktopImage.src,
        $component: $(component),
        addNudge: addNudge
      })), component.querySelector(".component-content"));
      if (!sliderStack) {
        component.style.opacity = 1;
      }
    }

    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */
  }, {
    key: "getDataFromComponent",
    value: function getDataFromComponent(component) {
      var desktopImage = component.querySelector(".intro-banner-image img");
      var mobileImage = component.querySelector(".intro-banner-image").dataset;
      var desktopImageSrc = resolveImageSrc(desktopImage);
      var bannerContent = component.querySelector(".intro-banner-text").innerHTML;
      var video = component.querySelector(".intro-banner-video-external");
      var externalVideo = video && video.innerHTML;
      var externalVideoStyle = {};
      if (externalVideo) {
        // auto play and mute
        var srcMatch = externalVideo.match(/src="([^"]+)"/i);
        var src = srcMatch.length ? srcMatch[0] : "";
        var argSep = src.indexOf("?") === -1 ? "?" : "&";
        externalVideo = externalVideo.replace(/src="([^"]+)"/i, "src=\"$1".concat(argSep, "autoplay=1&mute=1&autoMute=1\"")).replace("data-consent-src", "src").replace("data-category-consent", "data-cat-con");
        if (externalVideo.indexOf("youtube") !== -1) {
          var widthMatch = externalVideo.match(/width="([0-9]+)"/i);
          var width = widthMatch.length ? parseInt(widthMatch[1], 10) : 16;
          var heightMatch = externalVideo.match(/height="([0-9]+)"/i);
          var height = heightMatch.length ? parseInt(heightMatch[1], 10) : 9;
          externalVideoStyle = {
            width: "100%",
            height: "0",
            position: "relative",
            paddingBottom: "".concat(100 / (width / height), "%")
          };
        }
        if (externalVideo.indexOf("kaltura") !== -1) {
          externalVideo.replace(/{'/g, "{&quot;").replace(/':'/g, "&quot;:&quot;").replace(/'}/g, "&quot;}").replace(/':/g, "&quot;:").replace("<provider>", "[provider]").replace("<playback>", "[playback]");
        }
      }
      var circleSpot = true;
      if (component.className.indexOf("circle-") === -1) circleSpot = false;
      var mobileImageData = {
        mobileImagesSrc: mobileImage.mobileImage,
        mobileImageWidth: mobileImage.mobileImageWidth,
        mobileImageHeight: mobileImage.mobileImageHeight,
        mobileImageAlt: mobileImage.mobileImageAltText
      };
      return {
        desktopImage: desktopImage,
        desktopImageSrc: desktopImageSrc,
        mobileImageData: mobileImageData,
        bannerContent: bannerContent,
        circleSpot: circleSpot,
        externalVideo: externalVideo,
        externalVideoStyle: externalVideoStyle
      };
    }
  }]);
}(WDHComponent);
var demantBanner = new DemantIntroBannerSpot(".content .intro-banner:not(.hero)");
demantBanner.run();
var demantHeroBanner = new DemantIntroBannerSpot(".content .intro-banner.hero");
demantHeroBanner.reactApp = DemantIntroBannerHero;
demantHeroBanner.run();